import { getBrandConfig } from '@/config/config'
import { DetailedHTMLProps, ImgHTMLAttributes } from 'react'
import { cn } from '@vgw/tailwind-merger'

type AppLogoProps = DetailedHTMLProps<
  ImgHTMLAttributes<HTMLImageElement>,
  HTMLImageElement
>

export const AppLogo = ({ className, ...props }: AppLogoProps) => {
  const { logo } = getBrandConfig()

  return (
    <img
      {...props}
      {...logo}
      alt=""
      className={cn('h-full w-full object-contain', className)}
    />
  )
}
